import SearchBar from '@/components/company/filters/SearchBar';
import ClearFilterButton from '@/components/company/filters/ClearFilterButton';

interface RewardFiltersProps {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  clearFilters: () => void;
}

export const RewardFilters = ({ searchTerm, setSearchTerm, clearFilters }: RewardFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row justify-start mt-5 px-5 gap-2">
      <SearchBar
        value={searchTerm}
        onChange={setSearchTerm}
        placeholder="Cari nama bonus, periode, target, atau besaran bonus..."
        className="w-full md:w-72"
      />
      <ClearFilterButton onClear={clearFilters} />
    </div>
  );
};
